import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import { MdSave } from "react-icons/md";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { Loader, ScrollToTop } from "../../../components";

const UbahValidasiDataVerifikator = () => {
  const { user, dispatch } = useContext(AuthContext);
  const { screenSize } = useStateContext();
  const { id } = useParams();
  const navigate = useNavigate();

  const [dataVerifikasi, setDataVerifikasi] = useState("");
  const [selectedDataVerifikasi, setSelectedDataVerifikasi] = useState(null);
  const [dataVerifikasis, setDataVerifikasis] = useState([]);
  const [openDataVerifikasi, setOpenDataVerifikasi] = useState(false);
  let [pageDataVerifikasi, setPageDataVerifikasi] = useState(0);
  const [limitDataVerifikasi] = useState(10);
  const [pagesDataVerifikasi, setPagesDataVerifikasi] = useState(0);
  const [queryDataVerifikasi, setQueryDataVerifikasi] = useState("");
  const [searchTermDataVerifikasi, setSearchTermDataVerifikasi] = useState("");
  const [statusValid, setStatusValid] = useState("VALID");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getValidasiDataVerifikator();
  }, [id]);

  useEffect(() => {
    getDataVerifikasis();
  }, [pageDataVerifikasi, searchTermDataVerifikasi]);

  const handleAuthError = (err) => {
    if (err.response?.status === 401) {
      dispatch({ type: "LOGOUT" });
      navigate("/");
    }
  };

  const getValidasiDataVerifikator = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${tempUrl}/validasiDataVerifikators/${id}`, {
        id: user._id,
        token: user.token,
      });
      setDataVerifikasi(response.data.dataVerifikasi?._id || "");
      setSelectedDataVerifikasi(response.data.dataVerifikasi || null);
      setStatusValid(response.data.statusValid || "VALID");
    } catch (err) {
      handleAuthError(err);
      setError(err.response?.data?.message || "Gagal mengambil data Validasi Data Verifikator.");
    }
    setLoading(false);
  };

  const getDataVerifikasis = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${tempUrl}/dataVerifikasisPagination?available_validasi_data_verifikator=true&search_query=${encodeURIComponent(searchTermDataVerifikasi)}&page=${pageDataVerifikasi}&limit=${limitDataVerifikasi}`,
        {
          id: user._id,
          token: user.token,
        },
      );
      setQueryDataVerifikasi(searchTermDataVerifikasi);
      setDataVerifikasis(response.data.dataVerifikasis);
      setPageDataVerifikasi(response.data.page);
      setPagesDataVerifikasi(response.data.totalPage);
    } catch (err) {
      handleAuthError(err);
      setError(err.response?.data?.message || "Gagal mengambil data Data Verifikasi.");
    }
    setLoading(false);
  };

  const dataVerifikasiHandler = (value) => {
    const pickedDataVerifikasi = dataVerifikasis.find((item) => item._id === value);
    setDataVerifikasi(value);
    setSelectedDataVerifikasi(pickedDataVerifikasi || null);
    setOpenDataVerifikasi(false);
  };

  const handleChangeDataVerifikasi = (e, p) => {
    setPageDataVerifikasi(p - 1);
  };

  const searchDataDataVerifikasi = (event) => {
    event.preventDefault();
    setPageDataVerifikasi(0);
    setSearchTermDataVerifikasi(queryDataVerifikasi);
  };

  const updateValidasiDataVerifikator = async (event) => {
    event.preventDefault();

    if (!dataVerifikasi || !statusValid) {
      setError("Data Verifikasi dan status valid wajib diisi.");
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${tempUrl}/updateValidasiDataVerifikator/${id}`, {
        dataVerifikasi,
        statusValid,
        id: user._id,
        token: user.token,
      });
      navigate(`/validasiDataVerifikator/${id}`);
    } catch (err) {
      handleAuthError(err);
      setError(err.response?.data?.message || "Gagal mengubah Validasi Data Verifikator.");
    }
    setLoading(false);
  };

  const renderDialogDataVerifikasi = () => {
    return (
      <Dialog open={openDataVerifikasi} onClose={() => setOpenDataVerifikasi(false)} maxWidth="md" fullWidth>
        <DialogTitle>{`Pilih Data Verifikasi`}</DialogTitle>
        <DialogContent>
          <Form onSubmit={searchDataDataVerifikasi}>
            <div className="search-row mt-0 mb-3">
              <Form.Control
                value={queryDataVerifikasi}
                placeholder="Cari nama pemohon, no jual, nopol, atau alasan..."
                onChange={(e) => setQueryDataVerifikasi(e.target.value)}
              />
              <Button type="submit">Cari</Button>
            </div>
          </Form>
          <TableContainer component={Paper}>
            <Table aria-label="pilih Data Verifikasi">
              <TableHead>
                <TableRow>
                  <TableCell>Nama Pemohon</TableCell>
                  <TableCell>No Jual</TableCell>
                  <TableCell>Nopol</TableCell>
                  <TableCell>Alasan</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {dataVerifikasis.map((item) => (
                  <TableRow
                    key={item._id}
                    className="row-clickable"
                    onClick={() => dataVerifikasiHandler(item._id)}
                  >
                    <TableCell>{item.admin?.namaPemohon?.permohonan?.namaPemohon || "-"}</TableCell>
                    <TableCell>{item.admin?.noJual || "-"}</TableCell>
                    <TableCell>{item.admin?.nopol || "-"}</TableCell>
                    <TableCell>{item.alasan || "-"}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <div className="search-row">
            <Pagination
              count={pagesDataVerifikasi}
              page={pageDataVerifikasi + 1}
              onChange={handleChangeDataVerifikasi}
              color="primary"
              size={screenSize <= 600 ? "small" : "medium"}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button className="btn-back" variant="outline-secondary" type="button" onClick={() => setOpenDataVerifikasi(false)}>
            {"< Kembali"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div>
      <ScrollToTop />
      <div className="page-header">
        <div>
          <div className="page-kicker">Survey</div>
          <h1 className="page-title">Ubah Validasi Data Verifikator</h1>
        </div>
      </div>
      <section className="section-panel">
        {error && <Alert variant="warning">{error}</Alert>}
        <Form onSubmit={updateValidasiDataVerifikator}>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Data Verifikasi</Form.Label>
                <Form.Control
                  value={selectedDataVerifikasi?.admin?.namaPemohon?.permohonan?.namaPemohon || ""}
                  placeholder="PILIH VERIFIKATOR"
                  readOnly
                  onClick={() => setOpenDataVerifikasi(true)}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>No Jual</Form.Label>
                <Form.Control value={selectedDataVerifikasi?.admin?.noJual || ""} disabled readOnly />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Nopol</Form.Label>
                <Form.Control value={selectedDataVerifikasi?.admin?.nopol || ""} disabled readOnly />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Alasan Data Verifikasi</Form.Label>
                <Form.Control as="textarea" rows={3} value={selectedDataVerifikasi?.alasan || ""} disabled readOnly />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Status Valid</Form.Label>
                <Form.Select value={statusValid} onChange={(e) => setStatusValid(e.target.value)}>
                  <option value="VALID">VALID</option>
                  <option value="TIDAK VALID">TIDAK VALID</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
          <div className="form-actions mt-3">
            <Button className="btn-back" type="button" variant="outline-secondary" onClick={() => navigate(`/validasiDataVerifikator/${id}`)}>
              {"< Kembali"}
            </Button>
            <Button className="btn-icon" type="submit">
              <MdSave /> Simpan
            </Button>
          </div>
        </Form>
      </section>
      {renderDialogDataVerifikasi()}
    </div>
  );
};

export default UbahValidasiDataVerifikator;

